/**
 * CPAround, `/postbacks/cparound`. Generic PostbackQueryDto. Backoffice, TMA
 * and Telegram agree on this template verbatim.
 */
export const cparoundContract = {
    id: 'cparound',
    displayName: 'CPAround',
    route: 'cparound',
    trackingTagMacro: '{clickid}',
    amountBehavior: 'amount comes from {payout} on FTD/CPA. currency is not a CPAround macro; CPA hardcodes EUR.',
    duplicateParamPolicy: 'array-then-tolerant-last-wins',
    caseSensitiveParams: [],
    requiresFixedCurrencyForCpa: true,
    pitfalls: [],
    sourceRefs: ['apps/api/src/modules/postbacks/controllers/postbacks.controller.ts:383-419'],
    events: [
        {
            event: 'REG',
            eventValue: 'registration',
            params: [
                { ourParam: 'uid', macro: '{clickid}' },
                { ourParam: 'subid', macro: '{subid}' },
                { ourParam: 'tracking_tag', macro: '{clickid}' },
            ],
        },
        {
            event: 'FTD',
            eventValue: 'ftd',
            params: [
                { ourParam: 'uid', macro: '{clickid}' },
                { ourParam: 'subid', macro: '{subid}' },
                { ourParam: 'amount', macro: '{payout}' },
                { ourParam: 'tracking_tag', macro: '{clickid}' },
            ],
        },
        {
            event: 'QUALIFIED_CPA',
            eventValue: 'cpa',
            params: [
                { ourParam: 'uid', macro: '{clickid}' },
                { ourParam: 'subid', macro: '{subid}' },
                { ourParam: 'amount', macro: '{payout}' },
                { ourParam: 'currency', macro: 'EUR' },
                { ourParam: 'tracking_tag', macro: '{clickid}' },
            ],
            fixedParams: { currency: 'EUR' },
        },
    ],
};
//# sourceMappingURL=cparound.js.map